module.exports = __webpack_public_path__ + "img/kaggle_icon.9c35fcb2.svg";